"use client";
import * as fbq from "@/app/utils/fpixel"
import { conversion, CONVERSION_LABELS } from "@/app/utils/gtag"
import { Form, Formik, FormikHelpers } from "formik";
import CustomButton from "../CustomButton";
import InputField from "../inputs/InputField";
import * as Yup from "yup";
import Header from "../Header";
import TextAreaField from "../inputs/TextAreaField";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "next/navigation";
import Thankyou from "./ThankYou";
import { getProjectCodeBySlugOrID, getUtmMediumByName, getUtmSourceByName } from "@/app/utils/CRMMapper";
interface Option {
	value: string;
	label: string;
}

interface FormValues {
	type: string;
	first_name: string;
	mobile: string;
	email: string;
	destination_id?: string;
	unit_design_id?: string;
	looking_for: string;
}

interface GetInTouchProps {
	className?: string;
	isContactUs?: boolean;
	IsWidth?: string;
	destinationData?: any;
	NeighborhoodsPage?: boolean;
	NeighborhoodsDetailsPage?: boolean;
	selectedNeighborhood?: Option | null;
	setSelectedNeighborhood?: React.Dispatch<React.SetStateAction<Option | null>>;
	masterplanSelectedNeighborhood?: string;
	setMasterplanSelectedNeighborhood?: React.Dispatch<
		React.SetStateAction<string>
	>;
	slug?: string;
	masterplanSelectedUnit?: string;
	setMasterplanSelectedUnit?: React.Dispatch<React.SetStateAction<string>>;
	isRequestPage?: boolean;

}

const options: Option[] = [
	{ value: "option1", label: "Option 1" },
	{ value: "option2", label: "Option 2" },
	{ value: "option3", label: "Option 3" },
];

const GetInTouch: React.FC<GetInTouchProps> = ({
	isContactUs = false,
	IsWidth,
	destinationData,
	NeighborhoodsPage,
	NeighborhoodsDetailsPage,
	masterplanSelectedNeighborhood,
	setMasterplanSelectedNeighborhood,
	slug,
	masterplanSelectedUnit,
	setMasterplanSelectedUnit,
	className,
	isRequestPage= false
}) => {
	const [neighborhoodsOptions, setNeighborhoodsOptions] = useState<Option[]>(
		[]
	);
	const [selectedNeighborhood, setSelectedNeighborhood] =
		useState<Option | null>(null);
	const [unitsOptions, setUnitsOptions] = useState<Option[]>([]);
	const [selectedUnit, setSelectedUnit] = useState<Option | null>(null);
	const [loading, setLoading] = useState(false);
	const formRef = useRef<HTMLDivElement>(null);
	const initialValues: FormValues = {
		type: "talk_us",
		first_name: "",
		mobile: "",
		email: "",
		// destination_id: "",
		// unit_design_id: "",
		looking_for: "",
	};
	const neighborhoodsInitialValues: FormValues = {
		type: "unit_design_inquiry",
		first_name: "",
		mobile: "",
		email: "",
		// destination_id: "",
		unit_design_id: "",
		looking_for: "",
	};

	const validationSchema = Yup.object({
		first_name: Yup.string().required("Required").min(3, "Too Short!"),
		mobile: Yup.string()
			.required("Required")
			.trim()
			.min(10, "This is too short to be a phone number")
			.matches(
				/^(\+?\d{1,4}[\s-]?)?(\d{4}[\s-]?\d{3}[\s-]?\d{4})$/,
				"Use a valid mobile number"
			),

		email: Yup.string()
			.email("Please enter a valid email address")
			.required("Required")
			.matches(/^([a-zA-Z0-9_\-\.])/, "Please enter a valid email address"),
		looking_for: Yup.string().required("Required").min(3, "Too Short!"),
	});
	const neighborhoodsValidationSchema = Yup.object({
		first_name: Yup.string().required("Required").min(3, "Too Short!"),
		mobile: Yup.string()
			.required("Required")
			.trim()
			.min(10, "This is too short to be a phone number")
			.matches(
				/^(\+?\d{1,4}[\s-]?)?(\d{4}[\s-]?\d{3}[\s-]?\d{4})$/,
				"Use a valid mobile number"
			),

		email: Yup.string()
			.email("Please enter a valid email address")
			.required("Required")
			.matches(/^([a-zA-Z0-9_\-\.])/, "Please enter a valid email address"),

		// destination_id: Yup.string().required("Required"),
		// unit_design_id: Yup.string().required("Required"),
		// looking_for: Yup.string().required("Required"),
	});

	const [message, setMessage] = useState("");
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [activeTab, setActiveTab] = useState<"guest" | "owner">("guest");

	const params = useSearchParams();
	const utm_source = params.get("utm_source");
	const utm_medium = params.get("utm_medium");
	const utm_campaign = params.get("utm_campaign");

	const submitForms = async (formData: any) => {
		try {
			await fetch(
				"https://prod-144.westeurope.logic.azure.com:443/workflows/3a9dc9e1ab37445da523c7e74e2d76c9/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=7Sjeh6dRfyzQt6cpbbnQ6JxtYVhWDsV7_SGZjpKxnow",
				{
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify(formData),
					method: "POST",
				}
			).then(() => {
			})
		} catch (err) {
			// console.log(err);
		}
	};



	const handleSubmit = async (
		values: FormValues,
		{ setSubmitting, resetForm }: FormikHelpers<FormValues>
	) => {
		try {
			setLoading(true);
			const modifiedObject = Object.fromEntries(
				Object.entries(values || {}).filter(
					([key, value]) =>
						key !== "unit_design_id" || (key === "unit_design_id" && value)
				)
			);
			const formType = isContactUs && activeTab === "guest" ? "talk_us" :
				values?.unit_design_id ? "unit_design_inquiry" :
					values?.destination_id && !values?.unit_design_id ? "destination_inquiry" :
						"talk_us";

			const response = await fetch(
				`${process.env.NEXT_PUBLIC_STATIC_BASE_API_URL}api/inquiry`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						accept: "application/json",
					},
					body: JSON.stringify({
						...modifiedObject,
						type: isRequestPage ? "invitation_request" : formType,
					}),
				}
			);

			const data = await response.json();

			if (response.ok && data.code === 200) {
				// setMessage(data.messages[0] || "Form submitted successfully!")

				resetForm();
				setIsSubmitted(true);
				setTimeout(() => {
					setIsSubmitted(false);
				}, 5000);
				fbq.event("Lead");
				conversion(CONVERSION_LABELS.LEAD_FORM);
			} else {
				setMessage("Submission failed. Please try again.");
			}
			// console.log(values,masterplanSelectedNeighborhood, "values");


			// CRM Request
			const CRMData = {
				lead: {
					firstname: values.first_name,
					lastname: "",
					fullmobilenumber: values.mobile.replace(/\s/g, ""),
					email: values.email,
					message: values.looking_for,
					jobtitle: "",
					websitesource: isContactUs ? 2 : 1,
					integratedsource: getUtmSourceByName(utm_source),
					integrationmedium: getUtmMediumByName(utm_medium),
					campaignName: utm_campaign,
					...(getUtmMediumByName(utm_medium) == 19 ? { integrationmediumOther: utm_medium } : {}),
					//   MID YARD Project id
					//   project: (slug == "mid-yard" || values?.destination_id == "7") ? "cd09bd5a-27ce-ed11-b597-6045bd8c528e" : "",
					project: getProjectCodeBySlugOrID(slug || values?.destination_id),
				}
			}

			//   To send data to CRM only if utm_source, utm_medium and utm_campaign are present in the url
			if (utm_source && utm_medium && utm_campaign) {
				submitForms(CRMData);
			}

		} catch (error) {
			console.error("Error:", error);
		} finally {
			setSubmitting(false);
			setLoading(false);
			resetForm();
			if (NeighborhoodsDetailsPage) {
				setSelectedUnit(null);
				if (setMasterplanSelectedUnit) {
					setMasterplanSelectedUnit("");
				}
			} else if (NeighborhoodsPage || (isContactUs && activeTab === "owner")) {
				setSelectedNeighborhood(null);
				setSelectedUnit(null);
				if (setMasterplanSelectedNeighborhood) {
					setMasterplanSelectedNeighborhood("");
				}
			}
		}
	};

	// const params = useSearchParams();
	// const booking = params.get("book");

	// useEffect(() => {
	// 	if (booking) formRef.current?.scrollIntoView({ behavior: "smooth" });
	// }, [booking]);

	useEffect(() => {
		if (destinationData) {
			const neighborhoods = destinationData?.map((neighborhood: any) => ({
				value: neighborhood.id,
				label: neighborhood.name.en,
				slug: neighborhood.slug,
			}));
			setNeighborhoodsOptions(neighborhoods);
		}
	}, [destinationData]);
	return (
		<section
			className={`py-11 bg-oBlue-100 text-white px lg:py-[6.25rem] lg:flex lg:justify-between  ${className}`}
			ref={formRef}
			id="get_in_touch"
			style={{paddingTop:isRequestPage?'10rem':''}}
		>
			<div className="header_and_description lg:w-[31rem]">
				<Header
					title={ isRequestPage ? "You Are Invited" : "Get in touch"}
					description="Live in the warm, cosmopolitan scene of O West, where the core elements of beauty are all yours, where your core needs that define comfort are all around."
				/>
			</div>
			{!isSubmitted ? (
				<Formik
					enableReinitialize
					validateOnMount
					initialValues={
						(isContactUs && activeTab === "guest") ? initialValues :
							!isContactUs ? neighborhoodsInitialValues :
								neighborhoodsInitialValues
					}
					validationSchema={
						(isContactUs && activeTab === "guest") ? validationSchema :
							!isContactUs ? neighborhoodsValidationSchema :
								neighborhoodsValidationSchema
					}
					onSubmit={handleSubmit}
				>
					{(formik) => (
						<Form className={`form lg:w-[43.75rem] ${IsWidth || ""}`}>
							{/* Tab Selector */}
							{isContactUs && (
								<div className="mb-6">
									<div className="flex items-center bg-white/10 backdrop-blur-sm rounded-full p-1 border border-white/20">
										<button
											type="button"
											onClick={() => {
												setActiveTab("guest");
												formik.resetForm();
											}}
											className={`flex-1 px-6 py-3 rounded-full font-bold transition-all ${activeTab === "guest"
												? "bg-white text-oBlue-100"
												: "text-white/70 hover:text-white"
												}`}
										>
											GUEST
										</button>
										<button
											type="button"
											onClick={() => {
												setActiveTab("owner");
												formik.resetForm();
											}}
											className={`flex-1 px-6 py-3 rounded-full font-bold transition-all ${activeTab === "owner"
												? "bg-white text-oBlue-100"
												: "text-white/70 hover:text-white"
												}`}
										>
											HOME OWNER
										</button>
									</div>
								</div>
							)}
							<div className="form_inputs flex flex-col gap-[1.19rem]">
								<InputField
									name="first_name"
									placeholder="Full Name"
									autoComplete="name"
									floatingLabel
									error={
										formik.touched.first_name &&
										Boolean(formik.errors.first_name)
									}
									errorMessage={formik.errors.first_name}
									htmlFor="first_name"
									onChange={(e) => {
										formik.setFieldValue("first_name", e.target.value);
									}}
								/>
								<InputField
									name="mobile"
									placeholder="Mobile"
									autoComplete="tel"
									floatingLabel
									error={formik.touched.mobile && Boolean(formik.errors.mobile)}
									errorMessage={formik.errors.mobile}
									htmlFor="mobile"
									onChange={(e) => {
										formik.setFieldValue("mobile", e.target.value);
									}}
								/>
								<InputField
									name="email"
									placeholder="Email Address"
									type="email"
									floatingLabel
									autoComplete="email"
									error={formik.touched.email && Boolean(formik.errors.email)}
									errorMessage={formik.errors.email}
									htmlFor="email"
									onChange={(e) => {
										formik.setFieldValue("email", e.target.value);
									}}
								/>

								{/* {(!isContactUs || (isContactUs && activeTab === "owner")) && (
									<SelectGroup
										NeighborhoodsPage={NeighborhoodsPage || (isContactUs && activeTab === "owner")}
										neighborhoodsOptions={neighborhoodsOptions}
										formik={formik}
										masterplanSelectedNeighborhood={
											masterplanSelectedNeighborhood
										}
										setMasterplanSelectedNeighborhood={
											setMasterplanSelectedNeighborhood
										}
										unitsOptions={unitsOptions}
										masterplanSelectedUnit={masterplanSelectedUnit}
										setMasterplanSelectedUnit={setMasterplanSelectedUnit}
										neighborhoodsDetailsPage={NeighborhoodsDetailsPage}
										slug={slug}
										destinationData={destinationData}
									/>
								)} */}

								<TextAreaField
									name="looking_for"
									htmlFor="looking_for"
									placeholder="Message"
									floatingLabel
									error={
										formik.touched.looking_for &&
										Boolean(formik.errors.looking_for)
									}
									errorMessage={formik.errors.looking_for}
									onChange={(e) => {
										formik.setFieldValue("looking_for", e.target.value);
									}}
								/>
							</div>

							{message && (
								<p
									className={`mt-2 ${message.includes("success")
										? "text-green-500"
										: "text-red-500"
										}`}
								>
									{message}
								</p>
							)}

							<CustomButton
								text={`${isSubmitted ? "Thank you" : "Submit"}`}
								disabled={isSubmitted || loading}
								hasIcon={!isSubmitted}
								style="white"
								customClass="mt-[1.19rem]"
								type="submit"
							/>
						</Form>
					)}
				</Formik>
			) : (
				<Thankyou successMsg="Thank you for your inquiry! We will get back to you shortly." />
			)}
		</section>
	);
};

export default GetInTouch;
